import React, {useEffect, useState} from "react";
import PropTypes from "prop-types";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMinus, faCircle } from '@fortawesome/pro-solid-svg-icons'

function LegendItem({serie, clickable = false}) {

  const isActive = () => (serie.visible ? true : false);

  const [active, setActive] = useState(isActive());
  const picto = ('yAxis' in serie && (serie.yAxis.opposite || serie.options.type == 'spline')) ? faMinus : faCircle;

  const onClick = () => {
    isActive() ? serie.hide() : serie.show();
    setActive(isActive());
  }

  const clickProps = clickable ? {onClick} : {};

  useEffect(() => {
    setActive(isActive());
  }, [serie]);

  return (
    <>
      {(clickable || active) && <span className={`legend-item ${active ? 'active' : 'inactive'} ${clickable ? 'clickable' : ''}`} {...clickProps}>
        <FontAwesomeIcon icon={picto} size="xs" style={{color: active ? serie.color : ''}}/>&nbsp;{serie.name}
      </span>}
    </>
  )
}

export default function Legend({seriesOptions, ...props}) {

  const [show, setShow] = useState(props.show);
  const [clickable, setClickable] = useState(props.clickable);

  useEffect(() => {
    setShow(props.show);
  }, [props.show])

  useEffect(() => {
    setClickable(props.clickable);
  }, [props.clickable])

  return (
    <>
      { show && <div className="legend">
        { seriesOptions && seriesOptions.map((serie) => <LegendItem {...{serie, clickable}} key={serie.name}/>)}
      </div> }
    </>
  )
}

Legend.propTypes = {
  seriesOptions: PropTypes.array.isRequired,
  show: PropTypes.bool.isRequired,
  clickable: PropTypes.bool.isRequired
}
